import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Form,
  Modal,
  Row,
  Typography,
  message,
  Col,
  Input,
  Select,
  Button,
  Tabs,
  DatePicker,
  TimePicker,
} from "antd";
const { TabPane } = Tabs;
import QuotationModal from "../../../TransactionMasters/Quotations/QuotationsForm";
import { platformApi } from "../../../../api";
import { ContextAPI } from "../../../../ContextAPI";
import moment from "moment";
import { withRouter } from "react-router-dom";
import "./style.less";
import DiscardModal from "../../DiscardModal";
import { getPiopiy, piopiyDialUser } from "../../../../utils/piopiy";
import { callContext } from "../../../../App";
import { getUUID } from "../../../../_helpers/utils";

const { Item } = Form;
const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;
import DraggableResizableModal from "../../../DraggableResizableModal"

const CallingInterface = (props) => {
  const {
    visibility,
    setVisibility,
    createQuotation,
    customerDetail,
    getActivityByCustomer,
    form,
    type,
    activityType,
    moduleid,
    isFeedbackCall,
    saleRegisterId,
    feedbackApi
  } = props;
  const [quotationModal, setQuotationModal] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [enquiryType, setEnquiryType] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [date, setDate] = useState(null);
  const [timeValue, setTimeValue] = useState(null);
  const [time, setTime] = useState(null);
  const [remarks, setRemarks] = useState(null);
  const { loginCredintials } = useContext(ContextAPI);
  const { mobileNumber, setMobileNumber } = useContext(callContext);
  const [discardModal, setDiscardModal] = useState(false);
  const [qFlag, setQFlag] = useState(false);
  const enquiryTypes = ["Hot", "Warm", "Cold"];
  const [uid, setUid] = useState(null);
  const { getFieldDecorator, validateFields } = form;
  const [editId, setEditId] = useState("");
  const [getFeedback, setGetFeedback] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const token = localStorage.getItem("token");
  const telecmiUser = localStorage.getItem("selectedTelecmiUserId");

  const getDefaultPhone = () => {
    const primaryContact = customerDetail?.contacts?.filter(
      (contact) => contact.type === "Primary"
    );
    if (primaryContact.length) {
      setSelectedNumber(primaryContact[0].phone);
    }
  };

  const handleNumberChange = (value) => {
    setSelectedNumber(value);
  };

  const handleEnquiryChange = (value) => {
    setEnquiryType(value);
  };

  // Enhanced remark handler with real-time validation
  const handleRemarkChange = (event) => {
    const value = event.target.value;

    // Filter out special characters
    const filteredValue = value.replace(/[^a-zA-Z0-9\s.,!?'"-]/g, '');

    if (value !== filteredValue) {
      message.warning("Special characters are not allowed and have been removed");
    }

    // Limit to 500 characters
    if (filteredValue.length <= 500) {
      setRemarks(filteredValue);
    } else {
      message.warning("Remarks cannot exceed 500 characters");
    }
  };

  // Validate remarks function
  const validateRemarks = (rule, value, callback) => {
    if (!value) {
      callback(); // Empty is allowed
      return;
    }

    // Check for special characters
    const specialCharRegex = /[^a-zA-Z0-9\s.,!?'"-]/;
    if (specialCharRegex.test(value)) {
      callback('Special characters are not allowed in remarks');
      return;
    }

    // Check maximum length
    if (value.length > 500) {
      callback('Remarks cannot exceed 500 characters');
      return;
    }

    callback();
  };

  // Function to disable past dates
  const disabledDate = (current) => {
    // Can not select days before today
    return current && current < moment().startOf('day');
  };

  // Function to disable past times
  const disabledTime = (selectedDate) => {
    const now = moment();

    if (!selectedDate) {
      return {};
    }

    // For future dates, no time restrictions
    if (selectedDate.isAfter(now, 'day')) {
      return {};
    }

    // For today, disable past hours and minutes
    if (selectedDate.isSame(now, 'day')) {
      const currentHour = now.hour();
      const currentMinute = now.minute();

      return {
        disabledHours: () => {
          const hours = [];
          for (let i = 0; i < currentHour; i++) {
            hours.push(i);
          }
          return hours;
        },
        disabledMinutes: (selectedHour) => {
          const minutes = [];
          if (selectedHour === currentHour) {
            for (let i = 0; i <= currentMinute; i++) {
              minutes.push(i);
            }
          }
          return minutes;
        },
        disabledSeconds: () => {
          return [];
        }
      };
    }

    return {};
  };

  // Get disabled hours for the selected date
  const getDisabledHours = () => {
    const timeConfig = disabledTime(dateValue);
    return timeConfig.disabledHours ? timeConfig.disabledHours() : [];
  };

  // Get disabled minutes for the selected date and hour
  const getDisabledMinutes = (selectedHour) => {
    const timeConfig = disabledTime(dateValue);
    return timeConfig.disabledMinutes ? timeConfig.disabledMinutes(selectedHour) : [];
  };

  // Handle date change with validation
  const handleDateChange = (date) => {
    setDateValue(date);
    if (date) {
      setDate(date.format('DD-MM-YYYY'));

      // Validate existing time if any
      if (timeValue) {
        const selectedDateTime = moment(date)
          .set({
            hour: timeValue.hour(),
            minute: timeValue.minute(),
            second: 0
          });

        if (selectedDateTime.isBefore(moment())) {
          setTimeValue(null);
          setTime('');
          message.warning("Selected time was in the past, please select again");
        }
      }
    } else {
      setDate('');
    }
  };

  // Handle time change with validation
  const handleTimeChange = (time) => {
    if (time && dateValue) {
      const selectedDateTime = moment(dateValue)
        .set({
          hour: time.hour(),
          minute: time.minute(),
          second: 0
        });

      // Check if selected date/time is in the past
      if (selectedDateTime.isBefore(moment())) {
        message.error("Cannot select past date and time");
        return;
      }

      setTimeValue(time);
      setTime(time.format('HH:mm'));
    } else {
      setTimeValue(null);
      setTime('');
    }
  };

  const handleCall = () => {
    try {
      if (!telecmiUser) {
        message.error("Can't place call, Login to telecmi account to continue");
        return;
      }

      const UniqueId = getUUID();
      if (!token) {
        throw new Error("Token not found");
      }

      let mobileNumber = "91" + selectedNumber;
      setMobileNumber(mobileNumber);

      piopiyDialUser(getPiopiy(), mobileNumber, UniqueId, activityType, moduleid);
      setUid(UniqueId);
      setEditId(UniqueId);
    } catch (error) {
      message.error(error.message);
      console.error("Call failed:", error);
    }
  };

  const addActivity = () => {
    let payload = {
      customerId: customerDetail?.id,
      phone: selectedNumber,
      uniqueId: uid,
      activityType: activityType,
    };
    if (type === "serviceFollowup") {
      payload.type = "serviceFollowup";
    } else {
      payload.type = "outgoing";
    }
    platformApi
      .post("/api/activity/call", payload)
      .then((res) => {
        const { data } = res;
        setEditId(data.response.data.id);
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            message.success("Activity created successfully", 3);
          } else {
            message.error("Unable to save activity", 3);
          }
        } else {
          message.error("Unable to save activity", 3);
        }
      })
      .catch((err) => {
        message.error("Unable to save activity");
      });
  };

  const handleSubmit = () => {
    setSubmitted(true);
    // Validate form fields
    validateFields((err, values) => {
      if (err) {
        return;
      }

      if (!uid && !editId) {
        message.error("You can't add activity without placing a call");
        return;
      }

      // Validate follow-up date/time for non-feedback calls
      if (!isFeedbackCall) {
        if (!date || !time) {
          message.error("Please select both follow-up date and time");
          return;
        }

        if (!dateValue || !timeValue) {
          message.error("Invalid date or time selection");
          return;
        }

        const selectedDateTime = moment(dateValue)
          .set({
            hour: timeValue.hour(),
            minute: timeValue.minute(),
            second: 0
          });

        if (selectedDateTime.isBefore(moment())) {
          message.error("Follow-up date and time cannot be in the past");
          return;
        }
      }

      // Validate remarks
      if (remarks) {
        // Check for special characters
        const specialCharRegex = /[^a-zA-Z0-9\s.,!?'"-]/;
        if (specialCharRegex.test(remarks)) {
          message.error("Remarks contain invalid special characters");
          return;
        }

        // Check length
        if (remarks.length > 500) {
          message.error("Remarks cannot exceed 500 characters");
          return;
        }
      }

      let payload = {
        enquiryType,
        followUpDate: isFeedbackCall ? null : date,
        followUpTime: isFeedbackCall ? null : time,
        remarks,
        customerId: customerDetail?.id,
        phone: selectedNumber,
        uniqueId: uid,
        activityType: activityType,
        interactionType: isFeedbackCall ? "Sales Feedback Call" : "CALL ENQUIRY",
        type: "outgoing"
      };

      if (isFeedbackCall && getFeedback) {
        const apiEndpoint = feedbackApi || "/api/saleRegister/saveFeedback";
        platformApi.post(apiEndpoint, {
          id: saleRegisterId,
          customerFeedback: feedback
        }).then(res => {
          if (res.data.code !== 200) {
            message.error("Unable to save feedback");
          } else {
            message.success("Feedback saved successfully");
          }
        }).catch(err => {
          message.error("Unable to save feedback");
        });
      }

      platformApi.post(`/api/activity/call`, payload)
        .then((res) => {
          const { data } = res || {};
          // Route always returns HTTP 200; check business code
          if (data?.code !== 200 || (data?.response && data.response.code && data.response.code !== 200)) {
            message.error(
              data?.response?.message || data?.msg || "Failed to save activity"
            );
            return;
          }

          message.success("Activity saved successfully");
          try {
            close();
            clearFields();
            if (typeof getActivityByCustomer === "function") {
              getActivityByCustomer();
            }
          } catch (cleanupErr) {
            console.error("CallingInterface cleanup error:", cleanupErr);
          }
          if (isFeedbackCall) {
            props.history.goBack();
          }
        })
        .catch((err) => {
          console.error("Failed to save activity:", err);
          message.error("Failed to save activity");
        });
    });
  };

  const clearFields = () => {
    const now = moment();

    setEnquiryType(null);
    setRemarks(null);
    setDateValue(null);
    setTimeValue(null);
    setDate('');
    setTime('');
    setSelectedNumber(null);
    setUid(null);
    setEditId("");
    setGetFeedback(false);
    setFeedback("");
    setSubmitted(false);

    form.resetFields();
  };

  useEffect(() => {
    if (visibility) {
      getDefaultPhone();
    }
  }, [visibility]);

  const close = () => {
    setVisibility(false);
  };

  return (
    <DraggableResizableModal
      visible={visibility}
      cancelText="Cancel"
      okText="Save"
      onCancel={() => {
        getActivityByCustomer();
        clearFields();
        close();
      }}
      defaultWidth={700}
      defaultHeight={520}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto', padding: '0 16px' }}>
          <Row type="flex" justify="space-between" gutter={[16, 16]}>
            <Col span={10}>
              <strong>Customer Name: </strong>
              {customerDetail?.name}
            </Col>
            <Col span={14}>
              {!isFeedbackCall && (
                <Row type="flex" justify="space-between">
                  <Col span={8}>
                    <p>
                      <strong>
                        Next Followup Date & Time{" "}
                        <span style={{ color: "rgb(220,0,0)" }}>*</span>
                      </strong>
                    </p>
                  </Col>
                  <Col span={16}>
                    <Row gutter={[8, 8]} style={{ marginBottom: 8 }}>
                      <Col span={12}>
                        <Form.Item
                          validateStatus={submitted && !dateValue ? "error" : dateValue ? "success" : ""}
                          help={submitted && !dateValue ? "Follow-up date is required" : ""}
                        >
                          <DatePicker
                            value={dateValue}
                            onChange={handleDateChange}
                            disabledDate={disabledDate}
                            format="DD-MM-YYYY"
                            placeholder="Select date"
                            style={{ width: '100%' }}
                            size="small"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          validateStatus={submitted && !timeValue ? "error" : timeValue ? "success" : ""}
                          help={submitted && !timeValue ? "Follow-up time is required" : ""}
                        >
                          <TimePicker
                            value={timeValue}
                            onChange={handleTimeChange}
                            disabledHours={getDisabledHours}
                            disabledMinutes={getDisabledMinutes}
                            format="HH:mm"
                            placeholder="Select time"
                            style={{ width: '100%' }}
                            size="small"
                            disabled={!dateValue}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>

          <Row type="flex" justify="space-between" gutter={[16, 16]}>
            <Col span={10}>
              <Row type="flex" gutter={[16, 16]}>
                <Col span={6}>
                  <strong>Number: </strong>
                </Col>
                <Col span={12}>
                  <Form.Item required>
                    <Select
                      onChange={handleNumberChange}
                      value={selectedNumber || ""}
                      placeholder="Select phone number"
                    >
                      {customerDetail?.contacts?.length &&
                        customerDetail?.contacts?.map((contact) => {
                          if (!contact.DND)
                            return (
                              <Select.Option
                                key={contact.phone}
                                value={contact.phone}
                              >
                                {contact.phone}
                              </Select.Option>
                            );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            {type === "serviceFollowup" ? null : (
              <Col span={14}>
                {!isFeedbackCall && (
                  <Row type="flex" gutter={[16, 16]}>
                    <Col span={8}>
                      <strong>Enquiry Type: </strong>
                    </Col>
                    <Col span={15}>
                      <Item>
                        {getFieldDecorator(
                          "enquiryType",
                          {}
                        )(
                          <Select
                            showAction={["click", "focus"]}
                            placeholder="Enquiry Type"
                            onChange={handleEnquiryChange}
                          >
                            {enquiryTypes.map((type) => (
                              <Select.Option value={type} key={type}>
                                {type}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                      </Item>
                    </Col>
                  </Row>
                )}
              </Col>
            )}
          </Row>

          <Row
            type="flex"
            justify="space-between"
            style={{ marginTop: "10px" }}
            gutter={[16, 16]}
          >
            {type === "serviceFollowup" ? null : (
              <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
                <Button onClick={() => setQuotationModal(true)}>
                  Create Quotation
                </Button>
              </Col>
            )}
            <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
              <Button onClick={handleCall}>Call Customer</Button>
            </Col>

            {isFeedbackCall && (
              <Col span={24}>
                <div style={{ marginBottom: 8 }}>
                  <input
                    type="checkbox"
                    checked={getFeedback}
                    onChange={(e) => setGetFeedback(e.target.checked)}
                  />
                  <strong> Got Feedback?</strong>
                </div>
              </Col>
            )}

            <Col span={24}>
              <strong>Remarks: </strong>
              <Form.Item
                validateTrigger="onBlur"
                rules={[{ validator: validateRemarks }]}
              >
                {getFieldDecorator('remarks', {
                  initialValue: remarks,
                  normalize: (value) => value.replace(/[^a-zA-Z0-9\s.,!?'"-]/g, ''),
                  rules: [
                    {
                      validator: validateRemarks
                    }
                  ]
                })(
                  <TextArea
                    rows={4}
                    value={remarks}
                    onChange={handleRemarkChange}
                    placeholder="Enter remarks"
                    maxLength={500}
                    showCount
                  />
                )}
              </Form.Item>
            </Col>

            {isFeedbackCall && getFeedback && (
              <Col span={24} style={{ marginTop: 8 }}>
                <strong>Feedback: </strong>
                <TextArea
                  rows={4}
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  placeholder="Enter feedback"
                  maxLength={1000}
                  showCount
                />
              </Col>
            )}

            {type === "serviceFollowup" || isFeedbackCall ? null : (
              <Col span={24}>
                <span className="linkylink" onClick={() => setDiscardModal(true)}>
                  Discard Followup
                </span>
              </Col>
            )}
          </Row>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "12px 0",
            borderTop: "1px solid #f0f0f0",
            background: "#fafafa",
            textAlign: "right",
            marginTop: 16,
          }}
        >
          <Button
            onClick={() => {
              getActivityByCustomer();
              close();
              clearFields();
            }}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </div>

      <QuotationModal
        leadData={null}
        editable={true}
        cusData={customerDetail}
        open={quotationModal}
        emitData={(quotation, onSuccess) => {
          if (createQuotation) {
            createQuotation(quotation, (success, data) => {
              if (success) {
                setQuotationModal(false);
                if (getActivityByCustomer) getActivityByCustomer();
                if (onSuccess) {
                  onSuccess(true, data);
                }
              } else {
                if (onSuccess) onSuccess(false);
              }
            });
          } else {
            const formData = new FormData();
            formData.append("finalData", JSON.stringify(quotation));
            platformApi
              .post("/api/quotation", formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then((result) => {
                const { data } = result;
                if (data.code === 200 && data.response && data.response.code === 200) {
                  message.success("Quotation added successfully", 2);
                  setQuotationModal(false);
                  if (getActivityByCustomer) getActivityByCustomer();
                  if (onSuccess) onSuccess(true, data.response.data);
                } else {
                  const errorMsg = (data.response && data.response.message) || data.message || "Unknown API error";
                  message.error(`Failed to add quotation: ${errorMsg}`, 5);
                  if (onSuccess) onSuccess(false);
                }
              })
              .catch((error) => {
                console.error("Error on quotation : ", error);
                message.error(`Unable to add quotation: ${error.message || "Network error"}`, 5);
                if (onSuccess) onSuccess(false);
              });
          }
        }}
        close={() => {
          setQuotationModal(false);
        }}
      />
      <DiscardModal
        visibility={discardModal}
        setVisibility={setDiscardModal}
        customerDetail={customerDetail}
      />
    </DraggableResizableModal>
  );
};

const WrappedCallingInterface = Form.create({ name: "calling_interface" })(
  CallingInterface
);

export default withRouter(WrappedCallingInterface);